import { BrowserRouter } from "react-router-dom";
import AppRoutes from "./AppRoutes";
import GLSPharma from "./pages/home/HomePage";
import ScrollToTop from "./components/ScrollToTop";

function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <AppRoutes HomeComponent={GLSPharma} />
    </BrowserRouter>
  );
}

export default App;